import { QueryClient } from '@tanstack/react-query';

/**
 * The shared TanStack Query client (server-state cache). The reports coarse
 * endpoint (Plan 04) caches one entry per `{range,start,end}` filter through
 * this client. Conservative defaults for a read-mostly dashboard: a short
 * stale window and a single retry (the apiFetch wrapper already handles the
 * 401-refresh-retry, so query-level retries cover only transient network).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
